import { render, staticRenderFns } from "./SportelloPortinerieView.vue?vue&type=template&id=08795bd2&"
import script from "./SportelloPortinerieView.vue?vue&type=script&lang=ts&"
export * from "./SportelloPortinerieView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports